/**
 * Created by Jerker Nord on 2024-01-10.
 */
import {Loner} from "../../../Loner";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {LonerDuckAnimator} from "./LonerDuckAnimator";
import {LonerDuckSymbol} from "./symbols/LonerDuckSymbol";
import {LonerGameMode} from "../../../server/LonerGameMode";

export class LonerBottomDuckAnimator extends LonerDuckAnimator {

    constructor() {
        super();
        this.DUCKS_Y_POS = -10;
        this.DUCKS_X_START_POS = -260;
        this.DUCK_INIT_REEL = 4;
        this.DUCK_INIT_ROW = 2;
        this.BULLET_HOLE_POSITIONS = [new PIXI.Point(-145,-5), new PIXI.Point(148, -2)];
        this.init();
    }

    protected initBackground():void {
        this._background = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_BOTTOM_BACKGROUND)[0]);
        this._background.anchor.set(0.5, 0.5);
        this.addChild(this._background);
    }

    protected onMoveAllDucksComplete():void {
        Loner.ssdMainView.duckAnimatorCycleComplete(this.DUCK_INIT_ROW);
        this._mx2InfoUpdated = false;
        this._animationStepsCounter++;
        let removeDuck:LonerDuckSymbol = this._ducks.shift()!;
        this._ducksContainer.removeChild(removeDuck);
        this.doDuckReset(removeDuck);
        for(let i:number = 0; i < this._ducks.length; i++) {
            this._ducks[i].position.x += this._duckMoveAmount;
        }
        this._ducksContainer.position.x = 0;
        if(Loner.model.addDucksBottomReel.length == 0) {
            if(Loner.model.data.nextMode == LonerGameMode.NORMAL) {
                //console.log("Bottom ducks: End of FS");
            } else {
                //console.log("ERROR!! No bottom reel ducks left!");
            }
        } else {
            this.startNewDuckMoveCycle();
        }
    }

    protected startNewDuckMoveCycle():void{
        this.addNextDuck();
        //Setting new duck to correct position
        this._ducks[this._ducks.length - 1].position.x = this._ducks[this._ducks.length - 2].position.x + (this.SPACE_BETWEEN_DUCKS + this.DUCK_WIDTH);
        this.getMoveAllDucksTL();
    }

    public shootDuck(duckPosition:number, symbolName:string):void {
        duckPosition--;
        super.shootDuck(duckPosition, symbolName);
    }

    protected addNextDuck():void {
        //console.log("Next bottom duck is: " + Loner.model.addDucksBottomReel[0].duckName);
        this._nextDuck = Loner.duckSymbolPool.getSymbol(Loner.model.addDucksBottomReel[0].duckName,
            LonerDuckAnimator.DUCK_BASE_PATH + Loner.ssdMainView.getDuckValuePath(Loner.model.addDucksBottomReel[0].multiplier, Loner.model.addDucksBottomReel[0].duckName) +
            Loner.model.addDucksBottomReel[0].duckName + this.direction,
            Loner.model.addDucksBottomReel[0].multiplier);
        this._nextDuck.direction = this.direction;
        this._nextDuck.setMultiplier(Loner.model.addDucksBottomReel.shift()!.multiplier);
        this._nextDuck.row = this.DUCK_INIT_ROW;
        this._nextDuck.reel = this.DUCK_INIT_REEL;
        this._ducks.push(this._nextDuck);
        this._ducksContainer.addChild(this._nextDuck);
    }
}